(() => {
  const PRODUCT_VARIANT_ID = '53688720294181';
  const UNAVAILABLE_SAMPLE_TITLES = new Set(['Naturally Patinated Aluminium', 'Mild Steel']);

  const setupSwatches = (library) => {
    if (library.dataset.swatchCartReady === 'true') return;
    library.dataset.swatchCartReady = 'true';

    library.querySelectorAll('.fomu-material-library__card').forEach((card) => {
      const title = card.querySelector('h3')?.textContent?.trim();
      if (!title || card.querySelector('.fomu-material-swatch-action')) return;
      if (UNAVAILABLE_SAMPLE_TITLES.has(title)) return;

      const group = card.closest('.fomu-material-library__group')?.querySelector('h2')?.textContent?.trim() || '';
      const action = document.createElement('div');
      action.className = 'fomu-material-swatch-action';
      action.innerHTML = `
        <button type="button" class="fomu-material-swatch-button">Add sample — $5</button>
        <span class="fomu-material-swatch-note">Small sample</span>
        <span class="fomu-material-swatch-status" aria-live="polite"></span>
      `;

      const button = action.querySelector('.fomu-material-swatch-button');
      const status = action.querySelector('.fomu-material-swatch-status');

      button.addEventListener('click', async () => {
        if (button.disabled) return;
        button.disabled = true;
        const originalText = button.textContent;
        button.textContent = 'Adding…';
        status.textContent = '';

        try {
          const root = window.Shopify?.routes?.root || '/';
          const formData = new FormData();
          formData.append('id', PRODUCT_VARIANT_ID);
          formData.append('quantity', '1');
          formData.append('properties[Material]', title);
          formData.append('properties[Range]', group);
          formData.append('properties[Sample format]', 'Small physical sample/satchel');

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || 'Unable to add sample');
          }

          button.textContent = 'Added to cart';
          status.textContent = `${title} added to cart.`;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          window.setTimeout(() => {
            window.location.reload();
          }, 500);
        } catch (error) {
          console.error('Fomu swatch cart error:', error);
          button.disabled = false;
          button.textContent = originalText;
          status.textContent = 'Could not add this sample. Please try again.';
        }
      });

      card.appendChild(action);
    });
  };

  document.querySelectorAll('.fomu-material-library').forEach(setupSwatches);
})();
